export default {
  None: 'none',
  In: 'in',
  Out: 'out',
  InService: 'inService',
  OutOfService: 'outOfService',
  OutForRepair: 'outForRepair',
  Scrapped: 'scrapped',
}
